import { useEffect, useRef } from "react";

import { useBackNavigation } from "@hooks/backNavigation/useBackNavigation";
import {
  isInApp,
  postMessageToApp,
  readAppMessage,
} from "@/screens/utils/hybridAppHelpers";

/** Publishes back state to the native app (`NavState`) and runs its hardware back (`{ type: "back" }`). */
const NativeBackBridge = () => {
  const { goBack, canGoBack } = useBackNavigation();
  const goBackRef = useRef(goBack);
  goBackRef.current = goBack;

  useEffect(() => {
    postMessageToApp("NavState", { canGoBack });
  }, [canGoBack]);

  useEffect(() => {
    if (!isInApp()) {
      return undefined;
    }
    const onMessage = (event) => {
      if (readAppMessage(event)?.type === "back") {
        goBackRef.current({ hardware: true });
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return null;
};

export default NativeBackBridge;
